// Membership CTA accordion

jQuery(".m-membership__header a").bind("click",function(e){
    membership = jQuery(this).closest(".m-membership");
    jQuery(membership).toggleClass("js-m-membership--isactive");
    e.preventDefault();
});